/**
* @version GENERATOR_VERSION::20200422
* @DateTime 2020-05-04T19:46:29.218
* @Author <a href=\"mailto:bigmouthz@foxmail.com\">bigmouthz</a>
**/
import BasicLayout from '@/layouts/basic-layout';

const meta = {
auth: true
};

const pre = 'storagemanage-HouseRepeatPlan-'

export default 
{
path: '/storagemanage/houserepeatplan',
name: 'storagemanage-HouseRepeatPlan',
redirect: {
name: '${pre}-index'
}
,

meta:{
...meta,
},

component: BasicLayout ,
children:
[
{
path: 'index',
name: '${pre}HouseRepeatPlan-index',

meta:{
...meta,
title: '判重设置'
},

component: () => import('@/pages/storagemanage/houserepeatplan/index') ,
},
{
path: 'detail-edit/:id',
name: '${pre}HouseRepeatPlan-detail-edit',
auth: [
'hidden'
],

meta:{
...meta,
title: '判重设置编辑'
},

component: () => import('@/pages/storagemanage/houserepeatplan/detail-edit') ,
},
{
path: 'detail-edit',
name: '${pre}HouseRepeatPlandetail-create',
auth: [
'hidden'
],

meta:{
...meta,
title: '判重设置编辑'
},

component: () => import('@/pages/storagemanage/houserepeatplan/detail-edit') ,
},
{
path: 'detail-view/:id',
name: '${pre}HouseRepeatPlanView',
auth: [
'hidden'
],

meta:{
...meta,
title: '判重设置详情查看'
},

component: () => import('@/pages/storagemanage/houserepeatplan/detail-view') ,
},
]
};
